import { Record } from 'immutable'


const Question = Record({
  name:null,
  mail:null,
  content: null,
});
export default Question  ;
